function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function about() {
  return import(/* webpackChunkName: "page-about" */ '@/pages/about.vue')
}
function home() {
  return import(/* webpackChunkName: "page-home" */ '@/pages/home.vue')
}
function platform() {
  return import(/* webpackChunkName: "page-platform" */ '@/pages/platform.vue')
}
function pricing() {
  return import(/* webpackChunkName: "page-pricing" */ '@/pages/pricing.vue')
}
function privacy() {
  return import(/* webpackChunkName: "page-privacy" */ '@/pages/privacy.vue')
}
function profile() {
  return import(/* webpackChunkName: "page-profile" */ '@/pages/profile.vue')
}
function terms() {
  return import(/* webpackChunkName: "page-terms" */ '@/pages/terms.vue')
}
function topics() {
  return import(/* webpackChunkName: "page-topics" */ '@/pages/topics.vue')
}
function admin_index() {
  return import(
    /* webpackChunkName: "page-admin-index" */ '@/pages/admin/index.vue'
  )
}
function admin_assess() {
  return import(
    /* webpackChunkName: "page-admin-assess" */ '@/pages/admin/assess.vue'
  )
}
function admin_configure() {
  return import(
    /* webpackChunkName: "page-admin-configure" */ '@/pages/admin/configure.vue'
  )
}
function admin_product_type() {
  return import(
    /* webpackChunkName: "page-admin-product-type" */ '@/pages/admin/product-type.vue'
  )
}
function admin_sources() {
  return import(
    /* webpackChunkName: "page-admin-sources" */ '@/pages/admin/sources.vue'
  )
}
function admin_topics() {
  return import(
    /* webpackChunkName: "page-admin-topics" */ '@/pages/admin/topics.vue'
  )
}
function admin_user_activity() {
  return import(
    /* webpackChunkName: "page-admin-user-activity" */ '@/pages/admin/user-activity.vue'
  )
}
function admin_audience_index() {
  return import(
    /* webpackChunkName: "page-admin-audience-index" */ '@/pages/admin/audience/index.vue'
  )
}
function admin_course_creators_index() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-index" */ '@/pages/admin/course-creators/index.vue'
  )
}
function admin_engage_index() {
  return import(
    /* webpackChunkName: "page-admin-engage-index" */ '@/pages/admin/engage/index.vue'
  )
}
function admin_getStarted_index() {
  return import(
    /* webpackChunkName: "page-admin-getStarted-index" */ '@/pages/admin/getStarted/index.vue'
  )
}
function admin_lessons_index() {
  return import(
    /* webpackChunkName: "page-admin-lessons-index" */ '@/pages/admin/lessons/index.vue'
  )
}
function admin_pipeline_index() {
  return import(
    /* webpackChunkName: "page-admin-pipeline-index" */ '@/pages/admin/pipeline/index.vue'
  )
}
function admin_products_index() {
  return import(
    /* webpackChunkName: "page-admin-products-index" */ '@/pages/admin/products/index.vue'
  )
}
function admin_subscription_index() {
  return import(
    /* webpackChunkName: "page-admin-subscription-index" */ '@/pages/admin/subscription/index.vue'
  )
}
function m_auth() {
  return import(/* webpackChunkName: "page-m-auth" */ '@/pages/m/auth.vue')
}
function m_confirm() {
  return import(
    /* webpackChunkName: "page-m-confirm" */ '@/pages/m/confirm.vue'
  )
}
function m_crossStore() {
  return import(
    /* webpackChunkName: "page-m-crossStore" */ '@/pages/m/crossStore.vue'
  )
}
function m_edit() {
  return import(/* webpackChunkName: "page-m-edit" */ '@/pages/m/edit.vue')
}
function m_login() {
  return import(/* webpackChunkName: "page-m-login" */ '@/pages/m/login.vue')
}
function m_member() {
  return import(/* webpackChunkName: "page-m-member" */ '@/pages/m/member.vue')
}
function m_register() {
  return import(
    /* webpackChunkName: "page-m-register" */ '@/pages/m/register.vue'
  )
}
function m_verify() {
  return import(/* webpackChunkName: "page-m-verify" */ '@/pages/m/verify.vue')
}
function m_vip() {
  return import(/* webpackChunkName: "page-m-vip" */ '@/pages/m/vip.vue')
}
function m_vip2() {
  return import(/* webpackChunkName: "page-m-vip2" */ '@/pages/m/vip2.vue')
}
function admin_products_new() {
  return import(
    /* webpackChunkName: "page-admin-products-new" */ '@/pages/admin/products/new.vue'
  )
}
function m_onboard_user() {
  return import(
    /* webpackChunkName: "page-m-onboard-user" */ '@/pages/m/onboard/user.vue'
  )
}
function admin_lessons_new__courseId() {
  return import(
    /* webpackChunkName: "page-admin-lessons-new-courseId" */ '@/pages/admin/lessons/new/_courseId.vue'
  )
}
function admin_lessons_view__courseId() {
  return import(
    /* webpackChunkName: "page-admin-lessons-view-courseId" */ '@/pages/admin/lessons/view/_courseId.vue'
  )
}
function admin_course_creators__creatorId() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-creatorId" */ '@/pages/admin/course-creators/_creatorId.vue'
  )
}
function admin_enrolled_student__courseId() {
  return import(
    /* webpackChunkName: "page-admin-enrolled-student-courseId" */ '@/pages/admin/enrolled-student/_courseId.vue'
  )
}
function admin_products__courseId() {
  return import(
    /* webpackChunkName: "page-admin-products-courseId" */ '@/pages/admin/products/_courseId.vue'
  )
}
function admin_course_creators__coursecreatorId_new() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-coursecreatorId-new" */ '@/pages/admin/course-creators/_coursecreatorId/new.vue'
  )
}
function admin_course_creators__coursecreatorId_newlesson__courseId() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-coursecreatorId-newlesson-courseId" */ '@/pages/admin/course-creators/_coursecreatorId/newlesson/_courseId.vue'
  )
}
function admin_course_creators__coursecreatorId__courseId() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-coursecreatorId-courseId" */ '@/pages/admin/course-creators/_coursecreatorId/_courseId.vue'
  )
}
function admin_lessons__courseId__lessonId() {
  return import(
    /* webpackChunkName: "page-admin-lessons-courseId-lessonId" */ '@/pages/admin/lessons/_courseId/_lessonId.vue'
  )
}
function admin_course_creators__coursecreatorId__creatorcourseId__lessonId() {
  return import(
    /* webpackChunkName: "page-admin-course-creators-coursecreatorId-creatorcourseId-lessonId" */ '@/pages/admin/course-creators/_coursecreatorId/_creatorcourseId/_lessonId.vue'
  )
}
function _notFound() {
  return import(/* webpackChunkName: "page-notFound" */ '@/pages/_notFound.vue')
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
    meta: {
      customSite: false,
    },
  },
  {
    name: 'about',
    path: 'about',
    component: about,
    meta: {
      chunkName: 'misc',
    },
  },
  {
    name: 'home',
    path: 'home',
    component: home,
    meta: {
      requiresAuth: true,
      customSite: true,
    },
  },
  {
    name: 'platform',
    path: 'platform',
    component: platform,
    meta: {
      customSite: false,
    },
  },
  {
    name: 'pricing',
    path: 'pricing',
    component: pricing,
    meta: {
      chunkName: 'misc',
      customSite: true,
    },
  },
  {
    name: 'privacy',
    path: 'privacy',
    component: privacy,
    meta: {
      chunkName: 'misc',
      customSite: true,
    },
  },
  {
    name: 'profile',
    path: 'profile',
    component: profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'terms',
    path: 'terms',
    component: terms,
    meta: {
      chunkName: 'misc',
      customSite: true,
    },
  },
  {
    name: 'topics',
    path: 'topics',
    component: topics,
  },
  {
    name: 'admin',
    path: 'admin',
    component: admin_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-assess',
    path: 'admin/assess',
    component: admin_assess,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-configure',
    path: 'admin/configure',
    component: admin_configure,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-product-type',
    path: 'admin/product-type',
    component: admin_product_type,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-sources',
    path: 'admin/sources',
    component: admin_sources,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-topics',
    path: 'admin/topics',
    component: admin_topics,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-user-activity',
    path: 'admin/user-activity',
    component: admin_user_activity,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-audience',
    path: 'admin/audience',
    component: admin_audience_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-course-creators',
    path: 'admin/course-creators',
    component: admin_course_creators_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-engage',
    path: 'admin/engage',
    component: admin_engage_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-getStarted',
    path: 'admin/getStarted',
    component: admin_getStarted_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-lessons',
    path: 'admin/lessons',
    component: admin_lessons_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-pipeline',
    path: 'admin/pipeline',
    component: admin_pipeline_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-products',
    path: 'admin/products',
    component: admin_products_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-subscription',
    path: 'admin/subscription',
    component: admin_subscription_index,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'm-auth',
    path: 'm/auth',
    component: m_auth,
  },
  {
    name: 'm-confirm',
    path: 'm/confirm',
    component: m_confirm,
  },
  {
    name: 'm-crossStore',
    path: 'm/crossStore',
    component: m_crossStore,
  },
  {
    name: 'm-edit',
    path: 'm/edit',
    component: m_edit,
  },
  {
    name: 'm-login',
    path: 'm/login',
    component: m_login,
    meta: {
      customSite: true,
    },
  },
  {
    name: 'm-member',
    path: 'm/member',
    component: m_member,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'm-register',
    path: 'm/register',
    component: m_register,
    meta: {
      customSite: true,
    },
  },
  {
    name: 'm-verify',
    path: 'm/verify',
    component: m_verify,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'm-vip',
    path: 'm/vip',
    component: m_vip,
  },
  {
    name: 'm-vip2',
    path: 'm/vip2',
    component: m_vip2,
  },
  {
    name: 'admin-products-new',
    path: 'admin/products/new',
    component: admin_products_new,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'm-onboard-user',
    path: 'm/onboard/user',
    component: m_onboard_user,
  },
  {
    name: 'admin-lessons-new-courseId',
    path: 'admin/lessons/new/:courseId?',
    component: admin_lessons_new__courseId,
  },
  {
    name: 'admin-lessons-view-courseId',
    path: 'admin/lessons/view/:courseId?',
    component: admin_lessons_view__courseId,
  },
  {
    name: 'admin-course-creators-creatorId',
    path: 'admin/course-creators/:creatorId?',
    component: admin_course_creators__creatorId,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-enrolled-student-courseId',
    path: 'admin/enrolled-student/:courseId?',
    component: admin_enrolled_student__courseId,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-products-courseId',
    path: 'admin/products/:courseId?',
    component: admin_products__courseId,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-course-creators-coursecreatorId-new',
    path: 'admin/course-creators/:coursecreatorId/new',
    component: admin_course_creators__coursecreatorId_new,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-course-creators-coursecreatorId-newlesson-courseId',
    path: 'admin/course-creators/:coursecreatorId/newlesson/:courseId?',
    component: admin_course_creators__coursecreatorId_newlesson__courseId,
  },
  {
    name: 'admin-course-creators-coursecreatorId-courseId',
    path: 'admin/course-creators/:coursecreatorId/:courseId?',
    component: admin_course_creators__coursecreatorId__courseId,
    meta: {
      requireAdmin: true,
      customSite: true,
    },
  },
  {
    name: 'admin-lessons-courseId-lessonId',
    path: 'admin/lessons/:courseId/:lessonId?',
    component: admin_lessons__courseId__lessonId,
  },
  {
    name: 'admin-course-creators-coursecreatorId-creatorcourseId-lessonId',
    path: 'admin/course-creators/:coursecreatorId/:creatorcourseId/:lessonId?',
    component: admin_course_creators__coursecreatorId__creatorcourseId__lessonId,
  },
  {
    name: 'notFound',
    path: ':notFound?',
    component: _notFound,
  },
]
